<div style="position: relative; top: 0; z-index: 3; padding:2rem;">
  <div class="container mb-5">
    <div class="row pt-5">
      <a class="btn btn-outline-secondary m-2 ml-0" routerLink="/home">Accueil</a>
      <a class="btn btn-outline-secondary m-2" routerLink="/home" fragment="projects">Projets</a>
      <a class="btn btn-outline-secondary m-2" routerLink="/timeline">Timeline</a>
      <a class="btn btn-outline-secondary m-2" routerLink="/home" fragment="about">&Agrave; propos</a>
      <!--<a class="btn btn-outline-secondary m-2" routerLink="/contact">Contact</a>-->
    </div>
  </div>
  <div class="container">
    <router-outlet></router-outlet>
  </div>
</div>

<div id="background" style="top:0; right: 0; bottom: 0; left: 0; width: 100%; height: 100%; overflow: hidden;position: fixed;" class="">
  <div class="bg-light" style="z-index: 2; position: absolute; top: 2rem; right: 2rem; bottom: 2rem; left: 2rem; background-color: #FFF;">
  </div>
</div>